// extracted by mini-css-extract-plugin
module.exports = {"container":"contact_container__gXXqM","row":"contact_row__1qsZc","colText":"contact_colText__354A2","colMap":"contact_colMap__2FBi5","map":"contact_map__26Q9d"};